module.exports = {"slides":[{"icon":"p-2-bg-slider-circle-1","color":"orange","txt":"bg_1_p1_txt"},{"icon":"p-2-bg-slider-circle-2","color":"orange","txt":"bg_1_p2_txt"},{"icon":"p-2-bg-slider-circle-3","color":"orange","txt":"bg_1_p3_txt"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/bg_sl_p2_1.json
// module id = QyrB
// module chunks = 1